// https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#pbvgpo
import { insideBeforePurchase } from '../../relationChecker';
import { translate } from '../../../../../common/i18n';
import { barrierOffsetGenerator } from '../trade/components'
import theme from '../../theme';

Blockly.Blocks.get_payout_barrier = {
    init: function init() {
        this.appendValueInput('VAR')
            .setCheck('Number')
            .appendField(translate('Set payout percentage on'));
        this.appendDummyInput()
            .appendField(translate('from'))
            .appendField(new Blockly.FieldDropdown([
                [translate('Higher'), 'CALL'],
                [translate('Lower'), 'PUT'],
                [translate('Touch'), 'ONETOUCH'],
                [translate('No Touch'), 'NOTOUCH'],
            ]), 'TRADETYPE');
        barrierOffsetGenerator('BARRIEROFFSET', this);
        const barrierInput = this.getInput('BARRIEROFFSET');
        barrierInput.setVisible(true);
        // this.appendValueInput('BARRIER').appendField(translate('with barrier'));
        this.appendValueInput('DURATION').appendField(translate('and duration'))
            .appendField(new Blockly.FieldDropdown([
                [translate('ticks'), 't'],
                [translate('seconds'), 's'],
                [translate('minutes'), 'm'],
                [translate('hours'), 'h'],
            ]), 'DURATIONUNIT');

        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setInputsInline(false);
        this.setColour(theme.subBlockColor);
        this.setTooltip(translate('Get payout percentage of the selected trade type and barrier. This block creates a delay of 2 seconds'));
    },
    onchange: function onchange(ev) {
        insideBeforePurchase(this, ev, 'Payout');
        this.childBlocks_.map(a => {
            a.svgPath_.style.fill = theme.indicatorsColor;
            a.svgPathDark_.style.display = 'none';
        });
        // eslint-disable-next-line no-underscore-dangle
        for (let index = 0; index < this.svgGroup_.children.length; index++) {
            const a = this.svgGroup_.children[index];
            if (a.tagName === 'g' && (a.classList.length === 0)) {
                a.children[3].children[0].style.fill = theme.indicatorColorAccent;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyEditableText') {
                a.children[0].style.fill = theme.underBlockColor;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyDraggable') {
                a.children[1].style.fill = theme.subBlockColor;
            }
        }
    },
};

Blockly.JavaScript.get_payout_barrier = block => {
    const getBarrierValue = (barrierOffsetType, value) => {
        if (/^(\d+(\.\d+)?)$/.test(value)) {
            return barrierOffsetType === 'absolute' ? `'${value}'` : `'${barrierOffsetType}${value}'`;
        }
        return barrierOffsetType === 'absolute' ? value : `'${barrierOffsetType}' + ${value}`;
    };

    const type = block.getFieldValue('TRADETYPE'); // Correctly retrieves the value like 'CALL'
    // const barrier = Blockly.JavaScript.valueToCode(block, 'BARRIEROFFSET', Blockly.JavaScript.ORDER_ATOMIC) || '+0.5';
    let barrierOffsetValue = 'undefined';
    const barrierOffsetType = block.getFieldValue('BARRIEROFFSETTYPE_LIST');
    const value = Blockly.JavaScript.valueToCode(block, 'BARRIEROFFSET', Blockly.JavaScript.ORDER_ATOMIC) || '0';
    barrierOffsetValue = getBarrierValue(barrierOffsetType, value);
    const object = Blockly.JavaScript.valueToCode(block, 'VAR', Blockly.JavaScript.ORDER_ATOMIC) || 'new_object';
    const duration = Blockly.JavaScript.valueToCode(block, 'DURATION', Blockly.JavaScript.ORDER_ATOMIC) || '5';
    const durationUnit = block.getFieldValue('DURATIONUNIT'); // Correctly retrieves the value like 't'
    const code = `
    ${object} = getPayoutWithBarrier({type: '${type}', barrier: ${barrierOffsetValue}, durationUnit: '${durationUnit}', duration: '${duration}'});
    `;
    return code;
};


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/before_purchase/get_payout_barrier.js